import React from 'react';
import { connect } from "react-redux";
import './../main.scss'
import './../../main.css'


export class Main extends React.Component{
    constructor(props) {
        super(props);
    
        document.title= "Opći podaci"
        this.state={
            error: false,
            signin: true,
            userName: "",
            password: "",
        } 
    }

    render(){  
      
        return(    
            <main style={{}}>               
                <header>
                    <h1>
                        Početna
                    </h1>      
                </header> 
            </main>
    )
    }  
}

const mapStateToProps = state => {
    return {
        userLoggedIn: state.user.userLoggedIn,
        asideToggled: state.user.asideToggled
    };
  };
  
  const mapDispatchToProps = dispatch => {
    return {
      mapState: (type, data) => dispatch({ type: type, data: data}),
      API: (type, data) => dispatch({ type: type, data: data})
    };
  };
  
  
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(Main);
